module.exports = "<% _.each(faq, function(itm, idx){ %> <div class=\"faq-item hide-answer\"> <p class=question data-id=\"<%= itm.id %>\"> <i class=icon-arrow-right></i> <%= itm.title %> </p> <p class=answer><%= itm.content %></p> </div> <% }) %> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/app/pages/q&a/faq/itemTpl.html
// module id = 257
// module chunks = 0